<div class="drawer-layout">
	@if (configuration) {
		@if (!assigningMode) {
			<div class="drawer-content flex-row justify-content-space-between align-items-center">
				<button mat-button
						class="drawer-action-button"
						(click)="toggleAssigningMode()"
				>
					<mat-icon>add</mat-icon>
					<span class="button-label">Create new assignment...</span>
				</button>

				<app-filter-button [appliedFiltersCount]="appliedFiltersCount"
								   [active]="showingFilterBar"
								   (toggled)="toggleFilter()"
				></app-filter-button>
			</div>
		} @else {
			<div class="drawer-action-form show-form">
				<div class="form-line">
					<div class="form-icon">
						<mat-icon>person_add</mat-icon>
					</div>

					@if (availableVehiclesForAssignment.length === 0) {
						<div class="form-placeholder">
							No vehicle available
						</div>
					} @else {
						<mat-form-field appearance="outline" color="accent" class="w-100">
							<mat-label>Vehicle</mat-label>
							<mat-select
									[(ngModel)]="selectedVehicle"
									(ngModelChange)="onAssignmentFormChange()"
							>
								@for (asset of availableVehiclesForAssignment; track asset.id) {
									<mat-option [value]="asset">
										<span class="select-vehicle-option">{{ asset.name }} ({{ asset.driverName }}
											)</span>
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				</div>

				<div class="form-line">
					<div class="form-icon">
						<mat-icon>route</mat-icon>
					</div>

					<mat-form-field class="w-100" color="accent" appearance="outline">
						<mat-label>Route</mat-label>
						<mat-select [formControl]="routeSelectorControl" panelClass="routes-dropdown"
									(valueChange)="onAssignmentFormChange()">
							<!--<mat-option>&#45;&#45; None &#45;&#45;</mat-option>-->

							@for (itemConfigLevel of routeHierarchyItems; track $index) {
								<mat-optgroup [label]="itemConfigLevel.routeName">
									@for (item1stLevel of itemConfigLevel.children; track $index) {
										@if (item1stLevel.children) {
											<!-- category level 1 -->
											<mat-optgroup [label]="'&nbsp;' + item1stLevel.value">
												@for (item2ndLevel of item1stLevel.children; track $index) {
													@if (item2ndLevel.children) {
														<!-- category level 2 -->
														<mat-optgroup [label]="'&nbsp;&nbsp;' + item2ndLevel.value">
															@for (item3rdLevel of item2ndLevel.children; track $index) {
																@if (item3rdLevel.children) {
																	<!-- category level 3 -->
																	<mat-optgroup
																			[label]="'&nbsp;&nbsp;&nbsp;' + item3rdLevel.value">
																		@for (
                                                                            itemLeafLevel of item3rdLevel.children; track $index) {
																			@if (!itemLeafLevel.children) {
																				<mat-option
																						[value]="itemLeafLevel">{{ itemLeafLevel.value }}
																				</mat-option>
																			}
																		}
																	</mat-optgroup>
																} @else {
																	<mat-option
																			[value]="item3rdLevel">{{ item3rdLevel.value }}
																	</mat-option>
																}
															}
														</mat-optgroup>
													} @else {
														<mat-option [value]="item2ndLevel">{{ item2ndLevel.value }}
														</mat-option>
													}
												}
											</mat-optgroup>
										} @else {
											<mat-option [value]="item1stLevel">{{ item1stLevel.value }}</mat-option>
										}
									}
								</mat-optgroup>
							}

						</mat-select>
					</mat-form-field>
				</div>

				<div class="actions-wrapper">
					@if (assignmentActions.length && !showConfirmDialog) {
						<div class="buttons-wrapper">
							@for (action of assignmentActions; track $index) {
								@if ($index < 2) {
									<button mat-button
											color="accent"
											class="assign-button"
											(click)="action.onClick()">
										{{ action.title }}
									</button>
								}
							}

							@if (assignmentActions.length > 2) {
								<button mat-icon-button
										color="accent"
										class="assign-more-button"
										[matMenuTriggerFor]="assignActionsMenu">
									<mat-icon>keyboard_arrow_down</mat-icon>
									<div class="button-content">
									</div>
								</button>
								<mat-menu #assignActionsMenu="matMenu">
									@for (action of assignmentActions; track $index) {
										@if ($index >= 2) {
											<button mat-menu-item
													(click)="action.onClick()">
												{{ action.title }}
											</button>
										}
									}
								</mat-menu>
							}
						</div>
					}

					@if (showConfirmDialog) {
						<div class="confirm-headline">
							Reassign?
						</div>
						<div class="confirm-body">
							This vehicle is currently assigned to "<span
								class="confirm-strong">{{ getCurrentAssignmentInProgressIfAny()?.routeName }}</span>".
						</div>
						<div class="confirm-body">
							If you continue, "<span
								class="confirm-strong">{{ getCurrentAssignmentInProgressIfAny()?.routeName }}</span>"
							will be canceled and this vehicle will be reassigned to "<span
								class="confirm-strong">{{ selectedRoute.value }}</span>".
						</div>
						<!--<span>The current assignment {{ getCurrentAssignmentInProgressIfAny()?.routeName }} will be closed and driver will be instructed to proceed to this route immediately. Do you wish to proceed?</span>-->
						<div class="buttons-wrapper">
							<div class="confirm-wrapper">
								<button mat-button
										color=""
										class="confirm-button"
										(click)="cancelConfirmation()"
								>
									Cancel
								</button>
								<button mat-button
										color="accent"
										class="confirm-button"
										(click)="assignRoute(RouteAssignmentQueue.IMMEDIATE)"
								>
									Continue
								</button>
							</div>
						</div>
					}
				</div>
				<!--<div class="buttons-wrapper">
					<button mat-button
							color=""
							class="assign-button"
							(click)="assignRoute(RouteAssignmentQueue.END)"
							*ngIf="!!items && items.length >= 1"
					>
						Add to End of Queue
					</button>

					<button mat-button
							color=""
							class="assign-button"
							(click)="assignRoute(RouteAssignmentQueue.NEXT)"
							*ngIf="!!items && items.length >= 2"
					>
						Make next in queue
					</button>

					<button mat-button
							*ngIf="getCurrentAssignmentInProgressIfAny()"
							[color]="showConfirmDialog ? 'accent' : ''"
							class="assign-button"
							(click)="confirm()"
					>
						Start immediately
					</button>

					<button mat-button
							*ngIf="!getCurrentAssignmentInProgressIfAny()"
							color=""
							class="assign-button"
							(click)="assignRoute(RouteAssignmentQueue.IMMEDIATE)"
					>
						Add to Queue
					</button>
				</div>-->
			</div>
		}
	}

	<div>

		<app-filter-bar
				[origin]="'assignments'"
				[showingFilterBar]="showingFilterBar"
				[useDateFilter]="true"
				(dateFilterChanged)="onDateFilterChanged($event)"
				[useVehicleFilter]="true"
				(vehicleFilterChanged)="onVehicleFilterChanged($event)"
        [useRouteAssignmentStatusFilter]="true"
        (routeAssignmentStatusFilterChanged)="onRouteAssignmentStatusFilterChanged($event)"
				(appliedFiltersChanged)="appliedFiltersCount = $event"
		>
		</app-filter-bar>
	</div>

	@if (items?.length) {
		<div class="drawer-content">
			@for (item of items; track $index) {
				<app-card-menu-item [item]="item"></app-card-menu-item>
			}
		</div>
	}
</div>
